export const iconFontAwesomeEducationBookOpenReader = (
	<i className="fa-solid fa-book-open-reader"></i>
);
